import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  img: { marginRight: theme.spacing(1.5) },
  header: {
    fontWeight: ({ learnMoreMessage }: any) => {
      return learnMoreMessage ? 400 : 600;
    },
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    marginLeft: "auto",
  },
}));

export default function NotificationContent({
  message,
  icon = null,
  learnMoreMessage = false,
  actions = null,
}) {
  const classes = useStyles({ learnMoreMessage });

  return (
    <div className={classes.container}>
      {icon && <img src={icon} alt="" className={classes.img} />}
      <div className={classes.header}>{message}</div>
      <div className={classes.actions}>{actions}</div>
    </div>
  );
}
